var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c("h1", [_vm._v("Packages")]),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c(
                                        "fieldset",
                                        { staticClass: "inline-form" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Internal Code",
                                              rules: _vm.codeRules,
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.editedItem.code,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.code"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Price",
                                              rules: _vm.codeRules,
                                              required: "",
                                              prefix: "$"
                                            },
                                            model: {
                                              value: _vm.editedItem.price,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "price",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.price"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("p", [
                                        _c("strong", [_vm._v("Bookeo ID")]),
                                        _vm._v(
                                          " " + _vm._s(_vm.editedItem.productId)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.products,
          "items-per-page": 20
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }